import React from 'react'
import FullPageIntroWithFixedNavbar from '../Components/NavBar'


const Home = () => {

    return (
        <div> 
          <FullPageIntroWithFixedNavbar/>
        </div>
    )
}

export default Home